module.exports = __webpack_public_path__ + "270aae7feaf247722c0f7121b248e76f.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/media/18/18.jpg
// module id = 574
// module chunks = 0